import { render } from "./FromTextFileModal.vue?vue&type=template&id=68f4d961"
import script from "./FromTextFileModal.vue?vue&type=script&lang=js"
export * from "./FromTextFileModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__